import { MarketingLayout } from '@/components/site/marketing-layout';

export function StaticPage({
  title,
  intro,
  sections,
}: {
  title: string;
  intro?: string;
  sections: { heading: string; content: string }[];
}) {
  return (
    <MarketingLayout>
      <section className="container py-16">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-4xl font-bold tracking-tight">{title}</h1>
          {intro && <p className="mt-3 text-muted-foreground">{intro}</p>}
          <div className="mt-10 space-y-8">
            {sections.map((s) => (
              <article key={s.heading} className="space-y-2">
                <h2 className="text-xl font-semibold">{s.heading}</h2>
                <p className="text-muted-foreground">{s.content}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}

export const AssistancePage = () => (
  <StaticPage
    title="Assistance technique"
    intro="Notre support technique répond à toutes vos questions d'installation, configuration et exploitation."
    sections={[
      {
        heading: 'Hotline 7j/7',
        content: "Du lundi au dimanche de 8h à 20h au +33 1 00 00 00 00.",
      },
      {
        heading: 'Ticket en ligne',
        content: "Ouvrez un ticket directement depuis votre espace client (section Documents).",
      },
    ]}
  />
);

export const StatusPage = () => (
  <StaticPage
    title="État du réseau"
    intro="Aucun incident en cours sur notre infrastructure."
    sections={[
      { heading: 'Fibre — Île-de-France', content: 'Opérationnel.' },
      { heading: 'Fibre — Auvergne-Rhône-Alpes', content: 'Opérationnel.' },
      { heading: 'Fibre — Provence-Alpes-Côte d\'Azur', content: 'Opérationnel.' },
    ]}
  />
);

export const PrivacyPage = () => (
  <StaticPage
    title="Politique de confidentialité"
    sections={[
      {
        heading: 'Données collectées',
        content:
          "Informations d'identité, coordonnées, données projet (adresses, plans, photos), preuves de paiement.",
      },
      {
        heading: 'Finalités',
        content:
          'Exécution du contrat de raccordement fibre, facturation, suivi technique, obligations légales.',
      },
      {
        heading: 'Vos droits',
        content:
          'Droit d\'accès, de rectification, d\'effacement et de portabilité. Contactez privacy@bcl-telecom.fr.',
      },
    ]}
  />
);

export const TermsPage = () => (
  <StaticPage
    title="Conditions d'utilisation"
    sections={[
      {
        heading: 'Objet',
        content:
          'Les présentes CGU régissent l\'accès et l\'utilisation du portail client BCL Telecom.',
      },
      {
        heading: 'Création de compte',
        content:
          'L\'utilisateur s\'engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants.',
      },
    ]}
  />
);

export const CookiesPage = () => (
  <StaticPage
    title="Gestion des cookies"
    sections={[
      {
        heading: 'Cookies fonctionnels',
        content: "Strictement nécessaires au fonctionnement du portail (session, sécurité).",
      },
      {
        heading: 'Cookies analytiques',
        content: 'Soumis à votre consentement explicite via le bandeau de gestion.',
      },
    ]}
  />
);

export const OffresFibrePage = () => (
  <StaticPage
    title="Fibre optique"
    intro="Toutes nos solutions fibre, du raccordement individuel au déploiement collectif."
    sections={[
      {
        heading: 'Raccordement individuel',
        content: "Pack Sérénité Fibre à 340 €. Adapté aux maisons individuelles.",
      },
      {
        heading: 'Raccordement collectif',
        content: 'Pack Essentiel Fibre à 529 € ou Confort Fibre à 799 €.',
      },
    ]}
  />
);

export const OffresEntreprisePage = () => (
  <StaticPage
    title="Solutions entreprises"
    intro="Liens dédiés, GTR contractuelle, supervision réseau."
    sections={[
      {
        heading: 'Sur devis',
        content: 'Chaque solution entreprise est dimensionnée sur mesure. Contactez-nous.',
      },
    ]}
  />
);

export const OffresPromotionsPage = () => (
  <StaticPage
    title="Promotions"
    intro="Suivez nos offres promotionnelles en cours."
    sections={[
      { heading: 'Aucune promotion en cours', content: 'Revenez bientôt.' },
    ]}
  />
);
